import { PeOrderStatus } from 'enums/modules/pe/peOrderStatus';
import { useTranslation } from 'react-i18next';

type ReturnType = (status: PeOrderStatus) => string;

const usePeOrderStatusText = (): ReturnType => {
  const { t } = useTranslation();

  return (status) => {
    switch (status) {
      case PeOrderStatus.waitForApproval:
        return t('dealOrderStatusWaitForApproval');
      case PeOrderStatus.active:
        return t('dealOrderStatusActive');
      case PeOrderStatus.completed:
        return t('dealOrderStatusCompleted');
      case PeOrderStatus.canceled:
        return t('dealOrderStatusCanceled');
      default:
        return t('unknown');
    }
  };
};

export default usePeOrderStatusText;
